var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('masked-input',{ref:"cpf",staticClass:"form-control",attrs:{"mask":_vm.constroiMascara,"disabled":_vm.disabled},on:{"change":_vm.enviarParaPai},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}})}
var staticRenderFns = []

export { render, staticRenderFns }